const HISTORY_TRACK_PREFIX = "student_history_tracked_";

/**
 * Build a stable session key for the logged-in user + role.
 * History should fire once per login session, not on every page visit.
 */
export const getHistoryTrackKey = (body = {}) => {
  const role = body?.role || "unknown";
  // Prefer logged-in user identity so parent history is once per parent, not per child
  const userId =
    body?.logged_in_user_id ||
    body?.user_id ||
    body?.parent_id ||
    body?.student_id ||
    "anon";
  return `${HISTORY_TRACK_PREFIX}${role}_${userId}`;
};

export const hasTrackedStudentHistory = (body) => {
  try {
    return sessionStorage.getItem(getHistoryTrackKey(body)) === "1";
  } catch (e) {
    return false;
  }
};

export const markStudentHistoryTracked = (body) => {
  try {
    sessionStorage.setItem(getHistoryTrackKey(body), "1");
  } catch (e) {
    // ignore storage errors
  }
};

export const clearStudentHistoryTracked = () => {
  try {
    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith(HISTORY_TRACK_PREFIX)) {
        sessionStorage.removeItem(key);
      }
    });
  } catch (e) {
    // ignore storage errors
  }
};
